import { render, staticRenderFns } from "./CountDown.vue?vue&type=template&id=53cb9f20&scoped=true"
import script from "./CountDown.vue?vue&type=script&lang=js"
export * from "./CountDown.vue?vue&type=script&lang=js"
import style0 from "./CountDown.vue?vue&type=style&index=0&id=53cb9f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cb9f20",
  null
  
)

export default component.exports